import { TCouponQuote } from "../@types/data/coupon"
import { TTicketDisposal } from "../@types/data/ticket"
import { getAdditionalTax } from "./taxes"

export const COUPON_ZERO_TOTAL_MESSAGE =
  "Este cupom não pode ser usado neste pedido"

const COUPON_MESSAGES: Record<string, string> = {
  COUPON_NOT_FOUND: "Cupom inválido",
  COUPON_INACTIVE: "Este cupom está inativo",
  COUPON_EXPIRED: "Este cupom expirou",
  COUPON_SOLD_OUT: "Este cupom esgotou",
  COUPON_NOT_APPLICABLE: "Este cupom não vale para os itens do carrinho",
  CART_ITEM_UNAVAILABLE:
    "Um item do carrinho não está mais disponível. Vamos atualizar os ingressos.",
}

/** `code` vindo do backend é de cupom/carrinho? */
export const isCouponErrorCode = (code?: string): boolean =>
  !!code && code in COUPON_MESSAGES

export const getCouponErrorMessage = (code?: string, fallback?: string) =>
  (code && COUPON_MESSAGES[code]) ||
  fallback ||
  "Não foi possível validar o cupom. Tente novamente."

/** Itens do carrinho no formato esperado pelo validate. */
export const getCouponProducts = (tickets: TTicketDisposal[]) =>
  tickets
    .filter((t) => t.qnt > 0)
    .map((t) => ({ id: t.id, batch_id: t.batch_id, quantity: t.qnt }))

/** Assinatura do carrinho: muda quando item/quantidade muda. */
export const getCartKey = (tickets: TTicketDisposal[]) =>
  getCouponProducts(tickets)
    .map((p) => `${p.id}:${p.batch_id}:${p.quantity}`)
    .sort()
    .join("|")

/** Parte do cupom que viaja no state das rotas de pagamento. */
export type TCouponCharge = Pick<
  TCouponQuote,
  "code" | "subtotal" | "discountTotal" | "taxTotal" | "total" | "chargeClient"
>

/**
 * Valor a cobrar (centavos) com cupom: total do pedido + taxa adicional de
 * PIX/cartão, calculada sobre o preço já com desconto.
 */
export const getCouponCharge = (
  coupon: Pick<TCouponCharge, "subtotal" | "discountTotal" | "total">,
  props: {
    method: "" | "pix" | "credit"
    additionalTaxPix?: number | null
    additionalTaxCard?: number | null
  },
): number =>
  coupon.total +
  getAdditionalTax({
    baseTotal: coupon.subtotal - coupon.discountTotal,
    ...props,
  })
